/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import icon from '../../icons/invoice.png';
import SectionHeader from '../../components/sectionHeader';
import Table from './components/Table';
import { fetchInvoices } from './redux/actions';
import styles from './InvoicesList.module.scss';
import Loading from '../../components/loading/loading';
import Clickable from '../../components/clickable/Clickable';

class InvoiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      netSuiteInvoices: [],
      section: 'aerosimple',
      loadingStatus: false
    };
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { invoiceList, netSuiteList } = props;
    if (!state.invoices.length && invoiceList?.length>0) {
      const invoices = invoiceList;
      return {
        ...state,
        invoices
      };
    }
    if (!state.netSuiteInvoices.length && netSuiteList?.length>0) {
      const netSuiteInvoices = netSuiteList;
      return {
        ...state,
        netSuiteInvoices
      };
    }
    return null;
  }

  componentDidMount() {
    const { actionFetchInvoices, profile } = this.props;
    const isNetSuite = profile?.airport_configuration?.net_suite?.enabled || undefined;
    actionFetchInvoices(isNetSuite);
    this.setState({ loadingStatus: true });
  }

  componentDidUpdate(prevProps) {
    const { fetchAction } = this.props;
    if (prevProps.fetchAction.loading ===true && fetchAction.loading === false) {
      this.setState({ loadingStatus: false });
    }
  }

  handleTabClick = (section) => {
    this.setState({ section });
  }

  sortLogData= (key) => {
    const { currentSortState, currentSortDirection, section, netSuiteInvoices, invoices } = this.state;
    const isDescending = currentSortState === key && currentSortDirection === 'descending';
    const sortData = section === 'netSuite' ? [...netSuiteInvoices] : [...invoices];
    const direction = isDescending ? 'ascending' : 'descending';
    if (section === 'netSuite') {
      if (key === 'tranid') {
        sortData.sort((a, b) => (
          direction === 'ascending'
            ? a.tranid.localeCompare(b.tranid)
            : b.tranid.localeCompare(a.tranid)
        ));
      }

      if (key === 'status') {
        sortData.sort((a, b) => (
          direction === 'ascending'
            ? a.status.localeCompare(b.status)
            : b.status.localeCompare(a.status)
        ));
      }

      if (key === 'foreignamountunpaid') {
        sortData.sort((a, b) => (
          direction === 'ascending'
            ? Number(a.foreignamountunpaid) - Number(b.foreignamountunpaid)
            : Number(b.foreignamountunpaid) - Number(a.foreignamountunpaid)
        ));
      }

      if (key === 'duedate') {
        sortData.sort((a, b) => (
          direction === 'ascending'
            ? new Date(a.duedate) - new Date(b.duedate)
            : new Date(b.duedate) - new Date(a.duedate)
        ));
      }

      if (key === 'trandate') {
        sortData.sort((a, b) => (
          direction === 'ascending'
            ? new Date(a.trandate) - new Date(b.trandate)
            : new Date(b.trandate) - new Date(a.trandate)
        ));
      }

      this.setState({
        netSuiteInvoices: sortData,
        currentSortState: key,
        currentSortDirection: direction
      });
    } else {
      if (key === 'order_number') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.order_number > b.order_number) ? 1 : -1)),
            currentSortState: 'order_number',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.order_number > b.order_number) ? -1 : 1)),
          currentSortState: 'order_number',
          currentSortDirection: 'descending'
        });
      }
      if (key === 'logged_by') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.logged_by.fullname > b.logged_by.fullname) ? 1 : -1)),
            currentSortState: 'logged_by',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.logged_by.fullname > b.logged_by.fullname) ? -1 : 1)),
          currentSortState: 'logged_by',
          currentSortDirection: 'descending'
        });
      }
      if (key === 'invoice_date') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.invoice_date > b.invoice_date) ? 1 : -1)),
            currentSortState: 'invoice_date',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.invoice_date > b.invoice_date) ? -1 : 1)),
          currentSortState: 'invoice_date',
          currentSortDirection: 'descending'
        });
      }
      if (key === 'customer') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.customer?.name > b.customer?.name) ? 1 : -1)),
            currentSortState: 'customer',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.customer?.name > b.customer?.name) ? -1 : 1)),
          currentSortState: 'company',
          currentSortDirection: 'descending'
        });
      }

      if (key === 'amount') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((Number(a.amount) > Number(b.amount)) ? 1 : -1)),
            currentSortState: 'amount',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((Number(a.amount) > Number(b.amount)) ? -1 : 1)),
          currentSortState: 'amount',
          currentSortDirection: 'descending'
        });
      }

      if (key === 'payment_due') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.payment_due > b.payment_due) ? 1 : -1)),
            currentSortState: 'payment_due',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.payment_due > b.payment_due) ? -1 : 1)),
          currentSortState: 'payment_due',
          currentSortDirection: 'descending'
        });
      }
      if (key === 'status') {
        if (isDescending) {
          this.setState({
            invoices: sortData.sort((a, b) => ((a.status > b.status) ? 1 : -1)),
            currentSortState: 'status',
            currentSortDirection: 'ascending'
          });
          return;
        }
        this.setState({
          invoices: sortData.sort((a, b) => ((a.status > b.status) ? -1 : 1)),
          currentSortState: 'status',
          currentSortDirection: 'descending'
        });
      }
    }
  }

  render() {
    const { price_adjusted } = this.props;
    const { invoices, loadingStatus, section, netSuiteInvoices, currentSortState } = this.state;
    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <SectionHeader
          icon={icon}
          translationID="invoices.title"
          defaultTitle="Invoices"
        >
          {netSuiteInvoices && netSuiteInvoices?.length > 0 && (
            <div className={styles.navigation}>
              <Clickable className={section === 'aerosimple' ? styles.navigationActive : ''}
                onClick={() => this.handleTabClick('aerosimple')}
              >
                <FormattedMessage id="invoice.list.aerosimple" defaultMessage="Aerosimple" />
              </Clickable>
              <Clickable className={section === 'netSuite' ? styles.navigationActive : ''}
                onClick={() => this.handleTabClick('netSuite')}
              >
                <FormattedMessage id="invoice.list.netSuite" defaultMessage="Net Suite" />
              </Clickable>
            </div>
          )}
        </SectionHeader>
        <div style={{ display: 'flex', padding: '16px' }} className={styles.toolbar}>
          <div className={styles.counter}>
            <div className={styles.count}>
              <FormattedMessage id="invoice.list.all" defaultMessage="All Invoices " />
            </div>
          </div>
        </div>
        <div className={styles.invoiceContainer}>
          {invoices && section === 'aerosimple' && (
            <Table info={invoices} price_adjusted={price_adjusted} sortData={key => this.sortLogData(key)} sortKey={currentSortState} />
          )}
          {invoices && section === 'netSuite' && (
            <Table info={netSuiteInvoices} sortData={key => this.sortLogData(key)} isNetSuite sortKey={currentSortState} />
          )}
        </div>
      </>
    );
  }
}

InvoiceList.propTypes = {
  history: PropTypes.shape({}).isRequired,
  actionFetchInvoices: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  invoiceList: state.invoice.invoiceList,
  netSuiteList: state.invoice.netSuiteList,
  price_adjusted: state.auth.profile.price_adjusted,
  fetchAction: state.invoice.fetchAction,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionFetchInvoices: (isNetSuite) => {
    dispatch(fetchInvoices(isNetSuite));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList);
